import * as userDataActions from '@bca-user-data/store/user-data.actions';
import { UserDataActionTypes } from '@bca-user-data/store/user-data.actions';
import { IProduct } from '@bca-shared/models/product';
import { ImageDialogState } from '@bca-user-data/models/_enums';
import { IFaceImage } from '@bca-user-data/models/face-image';
import { IMetric } from '@bca-user-data/models/metric';

export const INITIAL_STATE: IState = {
  middleNames: [],
  selectedProduct: null,
  addressLoading: false,
  addressManualModeState: Object(),
  addressSearchFailed: false,
  middleNamesLoading: false,
  imageUploading: false,
  faceImage: null,
  faceImageMetrics: null,
  imageDialogState: ImageDialogState.CHOOSE
};

export interface IState {
  readonly middleNames: string[];
  readonly selectedProduct: IProduct;
  readonly addressLoading: boolean;
  readonly addressManualModeState: { [productId: string]: boolean };
  readonly addressSearchFailed: boolean;
  readonly middleNamesLoading: boolean;
  readonly imageUploading: boolean;
  readonly faceImage: IFaceImage;
  readonly faceImageMetrics: IMetric[];
  readonly imageDialogState: ImageDialogState;
}

export function reducer(state: IState = INITIAL_STATE, action: userDataActions.Action): IState {
  switch (action.type) {
    case UserDataActionTypes.SetAddressManualMode: {
      const { productId, manual } = action.payload;

      const addressManualModeState = { ...state.addressManualModeState };
      addressManualModeState[productId] = manual;

      return {
        ...state,
        addressManualModeState
      };
    }
    case UserDataActionTypes.SetAddressSearchFailed: {
      const { failed: addressSearchFailed } = action.payload;
      return {
        ...state,
        addressSearchFailed
      };
    }
    case UserDataActionTypes.SetAuthorizedSavePermission: {
      const { checked: authorizedSavePermission } = action.payload;

      const faceImage = { ...state.faceImage, authorizedSavePermission };

      return {
        ...state,
        faceImage
      };
    }
    case UserDataActionTypes.SetImageDialogState: {
      const { state: imageDialogState } = action.payload;
      return {
        ...state,
        imageDialogState
      };
    }
    case UserDataActionTypes.SaveImage: {
      const selectedProduct = {
        ...state.selectedProduct,
        user: {
          ...state.selectedProduct.user,
          image: { ...state.faceImage }
        }
      };
      return {
        ...state,
        selectedProduct
      };
    }
    case UserDataActionTypes.SetImage: {
      const faceImage = action.payload;
      return {
        ...state,
        faceImage
      };
    }
    case UserDataActionTypes.SetImageMetrics: {
      const metrics = action.payload;
      return {
        ...state,
        faceImageMetrics: metrics
          ? metrics.filter((metric, position, metrics) => {
              return (
                metrics.map(m => m['metric']).indexOf(metric['metric']) === position &&
                metrics.map(m => m['metricMessage']).indexOf(metric['metricMessage']) === position
              );
            })
          : null
      };
    }
    case UserDataActionTypes.ImageUploading: {
      const { loading: imageUploading } = action.payload;
      return {
        ...state,
        imageUploading
      };
    }
    case UserDataActionTypes.SetMiddleNames: {
      const { middleNames } = action.payload;
      return {
        ...state,
        middleNames
      };
    }
    case UserDataActionTypes.MiddleNamesLoading: {
      const { loading: middleNamesLoading } = action.payload;

      return {
        ...state,
        middleNamesLoading
      };
    }
    case UserDataActionTypes.SelectUser: {
      const user = action.payload;
      const selectedProduct = {
        ...state.selectedProduct,
        user: {
          ...user,
          id: user && user.id ? user.id : Date.now()
        }
      };

      return {
        ...state,
        selectedProduct
      };
    }
    case UserDataActionTypes.SelectProduct: {
      const selectedProduct = action.payload;
      return {
        ...state,
        selectedProduct
      };
    }
    case UserDataActionTypes.AddressLoading: {
      const { loading: addressLoading } = action.payload;
      return {
        ...state,
        addressLoading
      };
    }
  }

  return state;
}
